import { toRefs, reactive } from 'vue'
import { MATERIAL_TYPE_ID, MATERIAL_TYPE } from '@/components/material-selector/consts.js'
import { makeSelectorForm } from '@/components/material-selector/index.js'
export const selectPositionLabel = {
  materialPoolA: 'materialPoolA',
  materialPoolB: 'materialPoolB',
  watermarkImg: 'watermarkImg',
  backgroundImg: 'backgroundImg'
}
export const materialSizes = [{ label: '1280*720' }, { label: '720*1280' }]

export const getForm = () => {
  return {
    mixedModel: 1,
    mergerModel: 1,
    duplicateNum: '',
    materialPoolA: [],
    materialPoolB: [],
    backgroundImgSwitch: 0,
    background: {
      imgs: [],
      backgroundImgId: ''
    },

    subtitleStyleSwitch: 0,
    subtitleStyle: {
      subtitleStyleFontName: '思源黑体粗',
      subtitleStyleFontColor: '#FFFFFF',
      subtitleStyleFontSizeH: 40,
      subtitleStyleFontSizeV: 40,
      subtitleStyleBottomH: 60,
      subtitleStyleBottomV: 470,
      subtitleStyleDiaphaneity: 100
    },

    warningsSwitch: 0,
    warnings: {
      warningsContent: '创意仅供参考，实际内容以游戏为主，相关场景需达到一定关卡后可触发',
      warningsFontName: '思源黑体粗',
      warningsFontColor: '#FFFFFF',
      warningsFontSizeH: 12,
      warningsFontSizeV: 15,
      warningsBottomH: 4,
      warningsBottomV: 6,
      warningsDiaphaneity: 60
    },

    watermarkSwitch: 0,
    watermark: {
      img: null,
      watermarkImgId: '',
      watermarkDiaphaneity: 30,
      watermarkSportModel: 1
    },

    videoRatio: [1, 2],
    taskName: {
      imageName: '',
      imageNameStartNum: ''
    }
  }
}

export const useMaterialSelector = () => {
  const selectorModel = reactive({
    showSelectorModal: false,
    selectorProps: {
      selectPosition: selectPositionLabel.materialPoolA, // formData[selectPosition] 选择的确认后form表单key
      max: 200,
      assetType: MATERIAL_TYPE_ID[MATERIAL_TYPE.META],
      form: { ...makeSelectorForm(), size: '' }
    }
  })

  function onMetaMaterialSelect(selectPosition) {
    selectorModel.selectorProps.assetType = MATERIAL_TYPE_ID[MATERIAL_TYPE.META]
    selectorModel.selectorProps.max = 200
    selectorModel.selectorProps.form = { ...makeSelectorForm(), size: '' }
    selectorModel.selectorProps.selectPosition = selectPosition
    selectorModel.showSelectorModal = true
  }

  function onImageSelect(selectPosition) {
    selectorModel.selectorProps.assetType = MATERIAL_TYPE_ID[MATERIAL_TYPE.STICKER]
    selectorModel.selectorProps.max = 1
    selectorModel.selectorProps.form = { ...makeSelectorForm(), size: '' }

    // 包边允许最多选择10个，水印只能选择1个
    if (selectPosition === selectPositionLabel.backgroundImg) {
      selectorModel.selectorProps.max = 10
      // 包边图片默认值
      selectorModel.selectorProps.form.sizes = materialSizes.map((s) => s.label)
    }
    selectorModel.selectorProps.selectPosition = selectPosition
    selectorModel.showSelectorModal = true
  }

  function onSelectorClose() {
    selectorModel.showSelectorModal = false
  }

  return {
    ...toRefs(selectorModel),
    onImageSelect,
    onMetaMaterialSelect,
    onSelectorClose
  }
}
